import React from "react";
import logo from "../asset/logo.png";

const Header = () => {
  return (
    <div className="header">
      <img src={logo} />
    </div>
  );
};

export default Header;
